import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Lässt nur User mit Rolle <c>Admin</c> ins /admin-Backoffice. Alle anderen
 * (eingeloggt oder nicht) werden auf <c>/</c> zurückgeworfen — wir leaken
 * keine 403-Page, sondern verstecken den Bereich vollständig.
 *
 * SSR-Hinweis: <c>AuthService.loadCurrentUser()</c> überspringt den Server
 * (kein Cookie-Forwarding zum BFF), darum prüfen wir Auth ausschließlich im
 * Browser. Auf dem Server lassen wir durch — die Seite rendert kurz, der
 * Browser-Guard übernimmt die finale Entscheidung beim Hydrate.
 */
export const adminRoleGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) return true;

  if (auth.currentUser?.rolle === 'Admin') return true;
  return router.createUrlTree(['/']);
};
